/* Kai, the Kētos guide: storefront chat widget.
 * Mounted by sections/kbl-kai.liquid (test page) via window.KAI_CONFIG.
 * Talks to the Kai backend (store/kai) over SSE; renders an editorial
 * transcript with product cards, journal links, and follow-up pills.
 */
(function () {
  "use strict";
  if (window.__kaiBooted) return;
  window.__kaiBooted = true;

  var cfg = Object.assign(
    {
      endpoint: "",
      page_type: "page",
      product: null,
      launcher: "pill", // pill | none
      auto_open: false,
      starters: [
        "What should I take during a fast?",
        "Help me handle hunger",
        "Do electrolytes break a fast?"
      ]
    },
    window.KAI_CONFIG || {}
  );
  cfg.starters = (cfg.starters || [])
    .map(function (s) { return String(s).trim(); })
    .filter(Boolean);

  var LS_CONSENT = "kai_consent_at";
  var LS_THREAD = "kai_thread_v1";
  var THREAD_TTL = 24 * 60 * 60 * 1000;
  var DAILY_CAP = 40;
  var API_PATH = "/api/kai/chat";

  var state = {
    open: false,
    streaming: false,
    mock: false,
    consented: false, // in-memory fallback when localStorage is blocked
    threadId: null,
    messages: [] // {role:'user'|'assistant', content}
  };

  var els = {};

  /* ---------------- utilities ---------------- */

  function track(action, extra) {
    try {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(Object.assign({ event: "kai", kai_action: action }, extra || {}));
    } catch (e) {}
  }

  function lsGet(k) {
    try { return window.localStorage.getItem(k); } catch (e) { return null; }
  }
  function lsSet(k, v) {
    try { window.localStorage.setItem(k, v); } catch (e) {}
  }

  function el(tag, cls, html) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (html != null) n.innerHTML = html;
    return n;
  }

  function escapeHtml(s) {
    return String(s)
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;");
  }

  function safeUrl(u) {
    if (/^\/(?!\/)/.test(u)) return u;
    if (/^https:\/\//.test(u)) return u;
    return null;
  }

  // Minimal markdown: paragraphs, hyphen bullets, **bold**, *italic*, [x](url).
  function renderMarkdown(src) {
    var out = [];
    var lines = String(src).split(/\n/);
    var list = null;
    function closeList() {
      if (list) { out.push("<ul>" + list.join("") + "</ul>"); list = null; }
    }
    function inline(t) {
      t = escapeHtml(t);
      // Emphasis spans require non-space at both edges so trailing FDA
      // compliance asterisks ("supports hydration.*") are never consumed.
      t = t.replace(/\*\*(\S(?:[^*\n]*\S)?)\*\*/g, "<strong>$1</strong>");
      t = t.replace(/(^|[^*])\*(\S(?:[^*\n]*\S)?)\*(?!\*)/g, "$1<em>$2</em>");
      t = t.replace(/\[([^\]]+)\]\(([^)\s]+)\)/g, function (m, txt, url) {
        var u = safeUrl(url);
        return u ? '<a href="' + u + '" target="_blank" rel="noopener">' + txt + "</a>" : txt;
      });
      return t;
    }
    for (var i = 0; i < lines.length; i++) {
      var line = lines[i];
      var m = line.match(/^\s*-\s+(.*)/);
      if (m) {
        list = list || [];
        list.push("<li>" + inline(m[1]) + "</li>");
      } else if (line.trim() === "") {
        closeList();
      } else {
        closeList();
        out.push("<p>" + inline(line) + "</p>");
      }
    }
    closeList();
    return out.join("");
  }

  var EMAIL_RE = /[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}/g;
  var PHONE_RE = /(?:\+?\d{1,3}[\s.-]?)?\(?\d{3}\)?[\s.-]?\d{3}[\s.-]?\d{4}\b/g;
  function scrubPii(text) {
    return text.replace(EMAIL_RE, "[removed]").replace(PHONE_RE, "[removed]");
  }

  function money(cents) {
    var v = cents / 100;
    return "$" + (v % 1 === 0 ? v.toFixed(0) : v.toFixed(2));
  }

  function endpointUrl() {
    var base = (cfg.endpoint || "").replace(/\/+$/, "");
    return base + API_PATH;
  }

  function dayKey() {
    var d = new Date();
    return "kai_count_" + d.getFullYear() + "-" + (d.getMonth() + 1) + "-" + d.getDate();
  }
  function underCap() {
    return (parseInt(lsGet(dayKey()) || "0", 10) || 0) < DAILY_CAP;
  }
  function bumpCap() {
    lsSet(dayKey(), String((parseInt(lsGet(dayKey()) || "0", 10) || 0) + 1));
  }

  /* ---------------- thread persistence ---------------- */

  function loadThread() {
    try {
      var raw = lsGet(LS_THREAD);
      if (!raw) return;
      var t = JSON.parse(raw);
      if (!t || !t.at || Date.now() - t.at > THREAD_TTL) return;
      state.threadId = t.id || null;
      state.messages = Array.isArray(t.messages) ? t.messages.slice(-30) : [];
    } catch (e) {}
  }
  function saveThread() {
    try {
      lsSet(
        LS_THREAD,
        JSON.stringify({ id: state.threadId, at: Date.now(), messages: state.messages.slice(-30) })
      );
    } catch (e) {}
  }
  function newThreadId() {
    return "kai-" + Math.random().toString(36).slice(2, 12);
  }

  /* ---------------- DOM: launcher + panel ---------------- */

  function buildLauncher() {
    if (cfg.launcher === "none") return;
    var b = el("button", "kai-launcher");
    b.type = "button";
    b.setAttribute("aria-haspopup", "dialog");
    b.innerHTML = '<span class="kai-launcher__dot" aria-hidden="true"></span>Ask Kai';
    b.addEventListener("click", function () { state.open ? close() : open(); });
    document.body.appendChild(b);
    els.launcher = b;
  }

  function buildPanel() {
    var wrap = el("div", "kai-panel");
    wrap.setAttribute("role", "dialog");
    wrap.setAttribute("aria-modal", "false");
    wrap.setAttribute("aria-label", "Kai, the Kētos guide");
    wrap.hidden = true;

    var head = el("div", "kai-head");
    var hLeft = el("div", "kai-head__id");
    hLeft.innerHTML =
      '<span class="kai-head__name">Kai</span><span class="kai-head__kicker">KĒTOS GUIDE<span class="kai-demo" hidden>· DEMO</span></span>';
    var reset = el("button", "kai-iconbtn kai-reset");
    reset.type = "button";
    reset.title = "Start over";
    reset.setAttribute("aria-label", "Start the conversation over");
    reset.innerHTML = "&#8634;";
    reset.addEventListener("click", resetThread);
    var x = el("button", "kai-iconbtn kai-close");
    x.type = "button";
    x.setAttribute("aria-label", "Close chat");
    x.innerHTML = "&#10005;";
    x.addEventListener("click", close);
    head.appendChild(hLeft);
    head.appendChild(reset);
    head.appendChild(x);

    var body = el("div", "kai-body");
    body.setAttribute("aria-live", "polite");

    var foot = el("div", "kai-foot");
    var composer = el("form", "kai-composer");
    var input = el("textarea", "kai-input");
    input.rows = 1;
    input.placeholder = "Ask Kai";
    input.setAttribute("aria-label", "Ask Kai a question");
    input.maxLength = 1000;
    var sendBtn = el("button", "kai-send");
    sendBtn.type = "submit";
    sendBtn.setAttribute("aria-label", "Send");
    sendBtn.innerHTML = "&#8593;";
    composer.appendChild(input);
    composer.appendChild(sendBtn);
    composer.addEventListener("submit", function (e) {
      e.preventDefault();
      submit();
    });
    input.addEventListener("keydown", function (e) {
      if (e.key === "Enter" && !e.shiftKey) {
        e.preventDefault();
        submit();
      }
    });
    input.addEventListener("input", function () {
      input.style.height = "auto";
      input.style.height = Math.min(input.scrollHeight, 120) + "px";
    });
    var fine = el(
      "div",
      "kai-fine",
      "Kai is an AI guide and can make mistakes. Kai does not give medical advice. *These statements have not been evaluated by the Food and Drug Administration. Kētos products are not intended to diagnose, treat, cure, or prevent any disease."
    );
    foot.appendChild(composer);
    foot.appendChild(fine);

    wrap.appendChild(head);
    wrap.appendChild(body);
    wrap.appendChild(foot);
    document.body.appendChild(wrap);

    els.panel = wrap;
    els.body = body;
    els.input = input;
    els.send = sendBtn;
    els.demo = wrap.querySelector(".kai-demo");

    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape" && state.open) close();
    });
  }

  /* ---------------- consent gate ---------------- */

  function consentGiven() {
    return state.consented || !!lsGet(LS_CONSENT);
  }

  function renderConsent() {
    var card = el("div", "kai-consent");
    card.innerHTML =
      '<div class="kai-label">BEFORE WE START</div>' +
      "<p>Kai is a generative AI guide built by Kētos. Kai is not a doctor and does not give medical advice.</p>" +
      '<p>Your messages are sent to our AI provider to generate answers and may be reviewed to improve Kai. Your conversation is also saved in this browser for 24 hours. Please avoid sharing personal health details you would rather keep private. See our <a href="/policies/privacy-policy" target="_blank" rel="noopener">privacy policy</a>.</p>' +
      "<p>For medical questions, talk with your clinician.</p>";
    var agree = el("button", "kai-btn kai-btn--ink");
    agree.type = "button";
    agree.textContent = "I understand, let’s talk";
    agree.addEventListener("click", function () {
      state.consented = true;
      lsSet(LS_CONSENT, String(Date.now()));
      track("consent");
      card.remove();
      setComposerEnabled(true);
      renderWelcome();
      els.input.focus();
    });
    card.appendChild(agree);
    els.body.appendChild(card);
    setComposerEnabled(false);
  }

  function setComposerEnabled(on) {
    els.input.disabled = !on;
    els.send.disabled = !on;
    els.input.placeholder = on ? "Ask Kai" : "Agree above to start";
  }

  /* ---------------- transcript rendering ---------------- */

  function renderWelcome() {
    if (state.messages.length) {
      state.messages.forEach(function (m) {
        appendBubble(m.role, m.content, true);
      });
      scrollDown(true);
      return;
    }
    var w = el("div", "kai-welcome");
    w.innerHTML =
      '<div class="kai-label">KAI</div>' +
      "<p>Hey. I’m Kai, the Kētos guide. Ask me anything about fasting, hydration, or the Kētos products.</p>";
    els.body.appendChild(w);
    var pills = el("div", "kai-pills");
    (cfg.starters || []).slice(0, 4).forEach(function (s) {
      var p = el("button", "kai-pill");
      p.type = "button";
      p.textContent = s;
      p.addEventListener("click", function () {
        track("starter_click", { kai_text: s });
        sendMessage(s);
      });
      pills.appendChild(p);
    });
    els.body.appendChild(pills);
  }

  function appendBubble(role, content, isRestore) {
    var row = el("div", "kai-msg kai-msg--" + role);
    var label = el("div", "kai-label", role === "user" ? "YOU" : "KAI");
    var bodyEl = el("div", "kai-msg__body");
    if (role === "user") bodyEl.textContent = content;
    else bodyEl.innerHTML = renderMarkdown(content);
    row.appendChild(label);
    row.appendChild(bodyEl);
    els.body.appendChild(row);
    if (!isRestore) scrollDown();
    return bodyEl;
  }

  function appendNote(text) {
    var n = el("div", "kai-note", escapeHtml(text));
    els.body.appendChild(n);
    scrollDown();
  }

  function clearPills() {
    els.body.querySelectorAll(".kai-pills").forEach(function (p) { p.remove(); });
  }

  function scrollDown(instant) {
    try {
      els.body.scrollTo({ top: els.body.scrollHeight, behavior: instant ? "auto" : "smooth" });
    } catch (e) {
      els.body.scrollTop = els.body.scrollHeight;
    }
  }

  /* ---------------- product cards / articles / suggestions ---------------- */

  function renderProducts(handles) {
    handles.forEach(function (handle) {
      // Claim the transcript slot synchronously so cards keep their position
      // ahead of article and suggestion blocks that render instantly.
      var card = el("div", "kai-card");
      card.hidden = true;
      els.body.appendChild(card);
      fetch("/products/" + handle + ".js", { headers: { Accept: "application/json" } })
        .then(function (r) { if (!r.ok) throw new Error("product fetch"); return r.json(); })
        .then(function (p) {
          var img = p.featured_image
            ? '<img class="kai-card__img" src="' + escapeHtml(String(p.featured_image)) + '" alt="" loading="lazy">'
            : '<div class="kai-card__img kai-card__img--empty"></div>';
          card.innerHTML =
            img +
            '<div class="kai-card__info">' +
            '<div class="kai-card__title">' + escapeHtml(p.title) + "</div>" +
            '<div class="kai-card__price">' + money(p.price) + "</div>" +
            "</div>";
          var actions = el("div", "kai-card__actions");
          var add = el("button", "kai-btn kai-btn--green");
          add.type = "button";
          add.textContent = "Add to cart";
          add.addEventListener("click", function () {
            addToCart(p, add);
          });
          var view = el("a", "kai-card__view");
          view.href = safeUrl(String(p.url)) || "/products/" + handle;
          view.textContent = "View →";
          actions.appendChild(add);
          actions.appendChild(view);
          card.appendChild(actions);
          card.hidden = false;
          scrollDown();
          track("products_shown", { kai_product: handle });
        })
        .catch(function () {
          card.remove();
        });
    });
  }

  function addToCart(product, btn) {
    var variant = product.variants && product.variants[0];
    if (!variant) return;
    btn.disabled = true;
    btn.textContent = "Adding…";
    fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({
        items: [{ id: variant.id, quantity: 1, properties: { _kai: "1" } }]
      })
    })
      .then(function (r) { if (!r.ok) throw new Error("cart"); return r.json(); })
      .then(function () {
        btn.textContent = "Added ✓";
        btn.classList.add("is-done");
        track("add_to_cart", { kai_product: product.handle });
        var go = el("a", "kai-cartlink");
        go.href = "/cart";
        go.textContent = "View cart →";
        btn.parentNode.appendChild(go);
        document.dispatchEvent(new CustomEvent("kai:cart:added", { detail: { handle: product.handle } }));
      })
      .catch(function () {
        btn.disabled = false;
        btn.textContent = "Try again";
      });
  }

  function renderArticles(items) {
    var box = el("div", "kai-articles");
    box.appendChild(el("div", "kai-label", "FROM THE JOURNAL"));
    items.forEach(function (a) {
      var u = safeUrl(String(a.url));
      if (!u) return;
      var row = el("a", "kai-article");
      row.href = u;
      row.target = "_blank";
      row.rel = "noopener";
      row.textContent = a.title;
      box.appendChild(row);
      track("article_shown", { kai_url: u });
    });
    els.body.appendChild(box);
    scrollDown();
  }

  function renderSuggestions(items) {
    var pills = el("div", "kai-pills");
    items.forEach(function (s) {
      var p = el("button", "kai-pill");
      p.type = "button";
      p.textContent = s;
      p.addEventListener("click", function () {
        track("suggestion_click", { kai_text: s });
        sendMessage(s);
      });
      pills.appendChild(p);
    });
    els.body.appendChild(pills);
    scrollDown();
  }

  /* ---------------- send / stream ---------------- */

  function submit() {
    var text = els.input.value.trim();
    if (!text || state.streaming) return;
    if (!consentGiven()) return;
    if (!underCap()) {
      appendNote("You have reached today’s message limit. Email support@ketoshealth.com and a human will pick it up from here.");
      return; // keep the typed draft in the composer
    }
    els.input.value = "";
    els.input.style.height = "auto";
    sendMessage(text);
  }

  function getCart() {
    return fetch("/cart.js", { headers: { Accept: "application/json" } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (c) {
        if (!c || !Array.isArray(c.items)) return [];
        return c.items.slice(0, 10).map(function (i) {
          return { handle: i.handle, quantity: i.quantity };
        });
      })
      .catch(function () { return []; });
  }

  function sendMessage(rawText) {
    if (state.streaming) return;
    if (!consentGiven()) return;
    if (!underCap()) {
      appendNote("You have reached today’s message limit. Email support@ketoshealth.com and a human will pick it up from here.");
      return;
    }

    var text = scrubPii(rawText);
    clearPills();
    appendBubble("user", text);
    if (text !== rawText) {
      appendNote("Personal contact details were removed before sending.");
    }

    state.messages.push({ role: "user", content: text });
    if (!state.threadId) state.threadId = newThreadId();
    saveThread();
    track("message_sent", { kai_thread: state.threadId });

    state.streaming = true;
    els.send.disabled = true;

    var thinking = el("div", "kai-msg kai-msg--assistant kai-thinking");
    thinking.innerHTML = '<div class="kai-label">KAI</div><div class="kai-msg__body"><span class="kai-dots"><i></i><i></i><i></i></span></div>';
    els.body.appendChild(thinking);
    scrollDown();

    getCart().then(function (cart) {
      var payload = {
        thread_id: state.threadId,
        // Odd window size keeps the history user-first under normal
        // alternation; the server also drops leading assistant turns.
        messages: state.messages.slice(-11),
        context: {
          path: window.location.pathname,
          page_type: cfg.page_type,
          product: cfg.product,
          cart: cart
        }
      };
      return fetch(endpointUrl(), {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload)
      });
    })
      .then(function (res) {
        if (!res.ok || !res.body) throw new Error("bad response " + res.status);
        bumpCap(); // count only messages that actually reached the backend
        return consumeStream(res, thinking);
      })
      .catch(function (err) {
        thinking.remove();
        appendNote("Kai could not be reached. Please try again in a moment, or email support@ketoshealth.com.");
        track("error", { kai_error: String(err && err.message) });
      })
      .then(function () {
        state.streaming = false;
        els.send.disabled = false;
        try { els.input.focus(); } catch (e) {}
      });
  }

  function consumeStream(res, thinkingEl) {
    var reader = res.body.getReader();
    var decoder = new TextDecoder();
    var buffer = "";
    var answer = "";
    var bodyEl = null;
    var pendingRender = false;

    function ensureBubble() {
      if (bodyEl) return;
      thinkingEl.remove();
      bodyEl = appendBubble("assistant", "");
    }

    function render() {
      if (pendingRender || !bodyEl) return;
      pendingRender = true;
      window.requestAnimationFrame(function () {
        pendingRender = false;
        bodyEl.innerHTML = renderMarkdown(answer);
        scrollDown();
      });
    }

    function handleChunk(obj) {
      switch (obj.t) {
        case "meta":
          state.mock = !!obj.mock;
          if (els.demo) els.demo.hidden = !state.mock;
          if (obj.thread_id) state.threadId = obj.thread_id;
          break;
        case "content":
          answer += obj.text;
          ensureBubble();
          render();
          break;
        case "products":
          renderProducts(obj.items || []);
          break;
        case "articles":
          renderArticles(obj.items || []);
          break;
        case "suggestions":
          renderSuggestions(obj.items || []);
          break;
        case "error":
          ensureBubble();
          if (!answer) bodyEl.parentNode.remove();
          appendNote(obj.message || "Something went wrong.");
          break;
        case "done":
          break;
      }
    }

    function pump() {
      return reader.read().then(function (r) {
        if (r.done) return;
        buffer += decoder.decode(r.value, { stream: true });
        var frames = buffer.split("\n\n");
        buffer = frames.pop();
        frames.forEach(function (frame) {
          frame.split("\n").forEach(function (line) {
            if (line.indexOf("data: ") === 0) {
              try {
                handleChunk(JSON.parse(line.slice(6)));
              } catch (e) {}
            }
          });
        });
        return pump();
      });
    }

    return pump().then(function () {
      if (!bodyEl) thinkingEl.remove();
      if (answer) {
        bodyEl.innerHTML = renderMarkdown(answer);
        state.messages.push({ role: "assistant", content: answer });
        saveThread();
      }
      scrollDown();
    });
  }

  /* ---------------- open / close / reset ---------------- */

  function open() {
    if (!els.panel) return;
    state.open = true;
    els.panel.hidden = false;
    requestAnimationFrame(function () {
      els.panel.classList.add("is-open");
    });
    if (els.launcher) els.launcher.classList.add("is-hidden");
    if (!els.body.childNodes.length) {
      if (!consentGiven()) renderConsent();
      else renderWelcome();
    }
    if (consentGiven()) {
      try { els.input.focus(); } catch (e) {}
    }
    track("open", { kai_page: window.location.pathname });
  }

  function close() {
    state.open = false;
    els.panel.classList.remove("is-open");
    if (els.launcher) els.launcher.classList.remove("is-hidden");
    window.setTimeout(function () {
      if (!state.open) els.panel.hidden = true;
    }, 250);
    track("close");
  }

  function resetThread() {
    if (state.streaming) return;
    state.messages = [];
    state.threadId = null;
    saveThread();
    els.body.innerHTML = "";
    if (!consentGiven()) renderConsent();
    else renderWelcome();
    track("reset");
  }

  /* ---------------- boot ---------------- */

  function boot() {
    loadThread();
    buildLauncher();
    buildPanel();
    if (cfg.auto_open) open();
    // bfcache restore (Back after navigating away mid-stream) must never
    // leave the composer wedged in the streaming state.
    window.addEventListener("pageshow", function (e) {
      if (e.persisted) {
        state.streaming = false;
        if (els.send) els.send.disabled = !consentGiven() ? true : false;
        els.body.querySelectorAll(".kai-thinking").forEach(function (n) { n.remove(); });
      }
    });
    window.Kai = { open: open, close: close, send: sendMessage };
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }
})();
